import { cnAppConfig } from '@pst/app-config';

export const projectConfig = {
  appId: cnAppConfig.appId,
  region: cnAppConfig.region,
};
